import Reveal from "./Reveal";
import { WHY_CARDS } from "@/data/content";

function Tag({ tag }) {
  const isPerspective = tag.startsWith("Investment");
  return (
    <span
      className={`inline-block font-mono text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full border ${
        isPerspective ? "bg-gold text-navy border-gold font-semibold" : "border-navy/15 text-navy/60"
      }`}
    >
      {tag}
    </span>
  );
}

export default function WhyDholera() {
  const [featured, ...rest] = WHY_CARDS;
  return (
    <section id="why-dholera" className="py-24 lg:py-32 bg-paper" data-testid="why-dholera-section">
      <div className="container-luxe">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <Reveal className="lg:col-span-8">
            <p className="eyebrow mb-4">The Opportunity</p>
            <h2 className="font-serif font-semibold text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Why Dholera Smart City?
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-4">
            <p className="text-body text-base leading-relaxed">
              A greenfield smart city on Delhi–Mumbai Industrial Corridor land, built with government backing — and watched closely by land investors across India.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="why-dholera-bento-grid">
          <Reveal className="md:col-span-2 lg:row-span-2 relative overflow-hidden rounded-sm min-h-[380px] lg:min-h-full group" y={40}>
            <img src={featured.image} alt="Expressway connectivity to Dholera Smart City, Gujarat — infrastructure growth corridor" loading="lazy" className="absolute inset-0 w-full h-full object-cover img-treatment transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/20" />
            <div className="relative h-full flex flex-col justify-end p-8">
              <Tag tag={featured.tag} />
              <h3 className="mt-4 font-serif text-3xl text-white font-semibold leading-snug">{featured.title}</h3>
              <p className="mt-3 text-white/75 text-sm leading-relaxed">{featured.body}</p>
            </div>
          </Reveal>

          {rest.slice(0, 2).map((c, i) => (
            <Reveal key={c.title} delay={0.08 * (i + 1)} className="bg-white rounded-sm border border-border shadow-card p-7 flex flex-col gap-3 hover:shadow-gold-glow transition-shadow duration-300">
              <Tag tag={c.tag} />
              <h3 className="font-serif text-2xl text-navy font-semibold">{c.title}</h3>
              <p className="text-body text-sm leading-relaxed">{c.body}</p>
            </Reveal>
          ))}

          {rest.slice(2).map((c, i) => (
            <Reveal key={c.title} delay={0.08 * (i + 3)} className={`rounded-sm p-7 flex flex-col gap-3 ${c.tag.startsWith("Investment") ? "bg-navy border border-navy-3" : "bg-white border border-border shadow-card hover:shadow-gold-glow"} transition-shadow duration-300`}>
              <Tag tag={c.tag} />
              <h3 className={`font-serif text-2xl font-semibold ${c.tag.startsWith("Investment") ? "text-gold" : "text-navy"}`}>{c.title}</h3>
              <p className={`text-sm leading-relaxed ${c.tag.startsWith("Investment") ? "text-white/70" : "text-body"}`}>{c.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-8 border border-gold/40 bg-gold-light px-6 py-4 rounded-sm">
          <p className="font-mono text-[11px] leading-relaxed text-navy/70 uppercase tracking-[0.12em]">
            Note — Facts above are drawn from government and press sources (2026). Statements about growth are perspectives, not guarantees. Verify all information independently before investing.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
